<app-command [command]="update$" (success)="saved()">
  <app-details-modal
    [title]="title"
    [saveLabel]="saveLabel"
    [form]="form"
    (cancel)="cancel()"
    (save)="save()">
    <app-details-content>
      <ng-container *appLoad="let data of load$">
        <form [formGroup]="form">
          <div
            class="row"
            *ngIf="
              isNewDiaryNote
                | diaryNoteDisplayCreatedDate : data.content.createdDate
            ">
            <div class="col">
              <lds-date-input
                formControlName="createdDate"
                label="Created date"
                [isReadOnly]="true">
              </lds-date-input>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <lds-text-input
                formControlName="summary"
                label="Summary"
                placeholder="short summary"
                [maxlength]="128"
                [isRequired]="data.schema.summary | sharedRequirement"
                [validations]="{
                  required: 'Please provide a summary'
                }">
              </lds-text-input>
            </div>
          </div>
          <div class="row">
            <div class="col">
              <lds-text-area
                formControlName="details"
                label="Details"
                placeholder="note details"
                [rows]="10"
                [maxlength]="2000"
                [showRemaining]="true"
                [expandable]="true"
                [isRequired]="data.schema.details | sharedRequirement"
                [validations]="{
                  required: 'Please provide details'
                }">
              </lds-text-area>
            </div>
          </div>
        </form>
      </ng-container>
    </app-details-content>
  </app-details-modal>
</app-command>
